<nb-card>
	<nb-card-body class="transfer-documents-panel">
		<div class="row-wrapper">
			<label class="question-green">{{ groupTitle }}</label>
		</div>
		<div class="row-wrapper explanation-text" [innerHTML]="explanationText">
		</div>
		<div class="row-wrapper">
			@for (file of files; track file.name) {
				<a class="file-button details">
					{{ file.name }}
					<nb-icon class="button-icon" status="primary" icon="close-square" (click)="deleteDocument(file)"></nb-icon>
				</a>
			}
		</div>
		<div #anchor class="row-wrapper">
			<input id="{{groupTitle.split(' ').join('-')}}-upload-document-button" class="input-file" type="file" multiple
				   (change)="uploadDocuments($event)" [disabled]="blockInputs">
			<label for="{{groupTitle.split(' ').join('-')}}-upload-document-button" class="file-button">
				{{ 'transfer-documents.upload-btn' | translate }}
				<nb-icon class="button-icon" status="primary" icon="plus"></nb-icon>
			</label>
		</div>
		@if (fileHasUnsupportedExtension) {
			<div class="validation-message">{{ 'validations.file-has-unsupported-extension' | translate }}</div>
		}
		@if (fileIsTooBig) {
			<div class="validation-message">{{ 'validations.file-too-big' | translate }}</div>
		}
		@if (showFileIsRequired) {
			<div class="validation-message">{{ 'validations.required' | translate }}</div>
		}
		@if (showTooManyFiles) {
			<div class="validation-message">{{ 'validations.too-many-files' | translate }}</div>
		}
	</nb-card-body>
</nb-card>
